module.exports = __webpack_public_path__ + "static/media/3DPPA5.d2958fe6.jpg";